import { CSSProperties, FC, ReactElement, RefObject, isValidElement } from 'react';

import Button from '@components/buttons/Button';

import { isEmpty, noop } from '@helpers/util';

import './EmptyStateDisplay.scss';

interface ActionButtonProps {
    // Todo: Name this `actionButtonProps` or something similar?
    label: string;
    onClick: (e: any) => any;
    startIcon?: ReactElement;
    disabled?: boolean;
    tooltip?: string;
}

interface EmptyStateDisplayProps {
    divRef?: RefObject<HTMLDivElement>;
    graphic: ReactElement;
    className?: string;
    customContent?: ReactElement;
    label?: string;
    smallText?: string | ReactElement;
    actionButton?: ActionButtonProps | ReactElement | null;
    style?: CSSProperties;
}

const EmptyStateDisplay: FC<EmptyStateDisplayProps> = ({
    divRef,
    graphic,
    className = '',
    customContent,
    label,
    smallText,
    actionButton = null,
    style,
}) => {
    const ActionButton: FC = () => {
        if (!actionButton) {
            return <></>;
        }

        return isValidElement(actionButton) ? (
            actionButton
        ) : (
            <Button
                variant="filled"
                color="blue"
                onClick={(actionButton as ActionButtonProps)?.onClick || noop}
                startIcon={(actionButton as ActionButtonProps)?.startIcon}
                disabled={(actionButton as ActionButtonProps)?.disabled}
                tooltip={(actionButton as ActionButtonProps)?.tooltip}
            >
                {(actionButton as ActionButtonProps)?.label}
            </Button>
        );
    };

    return (
        <div ref={divRef} className={`empty-state-display ${className}`} style={style}>
            {graphic}
            {!isEmpty(customContent) && customContent}
            {!isEmpty(label) && <p className="empty-state-display_label">{label}</p>}
            {!isEmpty(smallText) && <p className="empty-state-display_small-text">{smallText}</p>}
            {!isEmpty(actionButton) && <ActionButton />}
        </div>
    );
};

export default EmptyStateDisplay;
